import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageContent from "../shared/PageContent/PageContent";
import PaySummaryPage from "./PaySummaryPage";
import UsageStatsPage from "./UsageStatsPage";
import EarningsBreakdownPage from "./EarningsBreakdownPage";
import "./OrganizationPage.css";

const REPORTS_TABS = [
  "Upfront Pay Summary",
  "Usage Stats",
  "Earnings Breakdown",
];

const TAB_TO_QUERY = {
  "Upfront Pay Summary": "paysummary",
  "Usage Stats": "usagestats",
  "Earnings Breakdown": "earningsbreakdown",
};

const QUERY_TO_TAB = {
  paysummary: "Upfront Pay Summary",
  usagestats: "Usage Stats",
  earningsbreakdown: "Earnings Breakdown",
};

const getReportTabFromSearch = search => {
  const params = new URLSearchParams(search);
  const tabParam = params.get("report");
  return QUERY_TO_TAB[tabParam] || "Upfront Pay Summary";
};

function ReportsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() =>
    getReportTabFromSearch(location.search)
  );

  useEffect(() => {
    const tabFromUrl = getReportTabFromSearch(location.search);
    setActiveTab(prev => (prev === tabFromUrl ? prev : tabFromUrl));
  }, [location.search]);

  useEffect(() => {
    const currentReportParam = new URLSearchParams(location.search).get(
      "report"
    );
    const nextReportParam = TAB_TO_QUERY[activeTab] || "paysummary";

    if (currentReportParam !== nextReportParam) {
      navigate(
        {
          pathname: location.pathname,
          search: `?report=${nextReportParam}`,
        },
        { replace: true }
      );
    }
  }, [activeTab, location.pathname, location.search, navigate]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Usage Stats":
        return <UsageStatsPage />;
      case "Earnings Breakdown":
        return <EarningsBreakdownPage />;
      case "Upfront Pay Summary":
      default:
        return <PaySummaryPage />;
    }
  };

  return (
    <PageContent
      customHeader={
        <div className="org-page-custom-header">
          <div className="org-page-header-left">
            <h1 className="org-page-main-title">Reports</h1>
            <nav className="org-page-nav-tabs" role="tablist">
              {REPORTS_TABS.map(tab => (
                <button
                  key={tab}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === tab}
                  className={`org-page-nav-tab${activeTab === tab ? " active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </nav>
          </div>
        </div>
      }
    >
      {renderActiveTab()}
    </PageContent>
  );
}

export default ReportsPage;
